import React, { useState, useEffect } from 'react';

import { useNavigate } from 'react-router';
import { useParams } from 'react-router-dom';

import MasterCardIcon from '../../../assets/images/MasterCard.svg';
import CardIcon from '../../../assets/images/PaymentCardIcon.svg';
import VisaIcon from '../../../assets/images/Visa.svg';
import { getPaymentInstrumentByLoan, getLoanPaymentMethods } from '../../../service/loan';

export const renderIconForCard = (type) => {
  switch (type) {
    case 'Visa':
      return (
        <div className="card-icon-wrapper">
          <img src={VisaIcon} className="card-icon" alt="card-icon" />
        </div>
      );
    case 'Mastercard':
      return (
        <div className="card-icon-wrapper">
          <img src={MasterCardIcon} className="card-icon" alt="card-icon" />
        </div>
      );
    default:
      return null;
  }
};

export const PaymentInstrument = ({ cardList }) => {
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [paymentInstrument, setPaymentInstrument] = useState([]);
  const navigate = useNavigate();
  const { id } = useParams();
  useEffect(() => {
    const fetchPaymentInstruments = async () => {
      try {
        const { data } = await getPaymentInstrumentByLoan(id);
        setPaymentInstrument(data);
        const tokenizedPaymentInstrument = data.filter((el) => el.dataType === 'tokenizedPayment');
        setPaymentInstrument(tokenizedPaymentInstrument);
      } catch (e) {
        console.error(e);
      }
    };

    const fetchPaymentMethods = async () => {
      try {
        const { data } = await getLoanPaymentMethods(id);
        setPaymentMethods(data);
      } catch (e) {
        console.error(e);
      }
    };
    fetchPaymentInstruments();
    fetchPaymentMethods();
  }, []);

  const renderPaymentCardLItem = (cardItem) => {
    const { type, number, cardId } = cardItem;
    return (
      <div key={number} className="card-details-row">
        {renderIconForCard(type)}
        <span>{`${type} - ${number.slice(-4)}`}</span>
        <span
          onClick={() => navigate(`/account/${id}/managePayment/deleteCard`, { state: cardId })}
          className="card-details-delete"
        >
          Delete
        </span>
      </div>
    );
  };

  return (
    <div className="payment-instrument-page">
      <div className="card-list-wrapper">
        <div className="added-card-list">
          <h3>Payment method</h3>
          {cardList &&
            cardList.length !== 0 &&
            cardList.map((cardItem) => renderPaymentCardLItem(cardItem))}
        </div>
      </div>
      <div className="add-card-section-wrapper">
        <div className="add-card-section">
          <p>Add payment method to your account</p>
          <div
            onClick={() => navigate(`/account/${id}/managePayment/addCard`)}
            className="add-card-row"
          >
            <img src={CardIcon} className="card-icon" alt="card-icon" />
            <span>Add credit or debit card</span>
          </div>
        </div>
      </div>
    </div>
  );
};
